export const GET_ACCOUNT_PAYMENT = "GET_ACCOUNT_PAYMENT";
export const GET_COMPANY_LIST = "GET_COMPANY_LIST";
export const GET_PAYMENT_CATEGORY_LIST = "GET_PAYMENT_CATEGORY_LIST";
export const GET_ACCOUNT_PAYMENT_DETAIL = "GET_ACCOUNT_PAYMENT_DETAIL";
export const GET_COMPANY_BANK_ACCOUNT_LIST = "GET_COMPANY_BANK_ACCOUNT_LIST";
export const GET_PAYMENT_MODE_CATEGORY_LIST = "GET_PAYMENT_MODE_CATEGORY_LIST";
export const GET_PAYMENT_MODE_LIST = "GET_PAYMENT_MODE_LIST";
export const GET_PAYMENT_MODE_FOR_PAYMENT_RECEIPT =
  "GET_PAYMENT_MODE_FOR_PAYMENT_RECEIPT";
export const GET_ACCOUNT_PAYMENT_PAID_LIST = "GET_ACCOUNT_PAYMENT_PAID_LIST";
export const GET_ACCOUNT_PAYMENT_PAID_DETAIL =
  "GET_ACCOUNT_PAYMENT_PAID_DETAIL";
export const GET_PROFITABLE_REPORT_GROUP = "GET_PROFITABLE_REPORT_GROUP";
export const GET_GROUP_EXPORT = "GET_GROUP_EXPORT";
export const GET_PROFITABLE_REPORT_CATEGORY = "GET_PROFITABLE_REPORT_CATEGORY";
export const GET_PROFITABLE_REPORT_CATEGORY_EXPORT =
  "GET_PROFITABLE_REPORT_CATEGORY_EXPORT";
export const GET_PROFITABLE_REPORT_ITEM = "GET_PROFITABLE_REPORT_ITEM";
export const GET_PROJECT_LOAN = "GET_PROJECT_LOAN";
export const GET_PROJECT_LOAN_EXPORT = "GET_PROJECT_LOAN_EXPORT";
export const GET_PROJECT_LOAN_STATUS = "GET_PROJECT_LOAN_STATUS";
export const GET_PROJECT_LOAN_DETAIL = "GET_PROJECT_LOAN_DETAIL";
export const GET_PROJECT_LOAN_PROCESS = "GET_PROJECT_LOAN_PROCESS";
export const GET_PROJECT_LOAN_PROCESS_EXPORT =
  "GET_PROJECT_LOAN_PROCESS_EXPORT";
export const GET_LOAN_PROCESS_FOR_PROCESS_PLAN_ADD =
  "GET_LOAN_PROCESS_FOR_PROCESS_PLAN_ADD";
export const GET_LOAN_PANEL_FOR_PROCESS_PLAN_ADD =
  "GET_LOAN_PANEL_FOR_PROCESS_PLAN_ADD";
export const GET_PROJECT_MORTGAGE = "GET_PROJECT_MORTGAGE";
export const GET_PROJECT_MORTGAGE_EXPORT = "GET_PROJECT_MORTGAGE_EXPORT";
export const GET_PROJECT_MORTGAGE_DETAILS = "GET_PROJECT_MORTGAGE_DETAILS";
export const GET_LOAN_PROCESS_STATUS = "GET_LOAN_PROCESS_STATUS";
export const GET_LOAN_PROCESS_STATUS_EXPORT = "GET_LOAN_PROCESS_STATUS_EXPORT";
export const GET_LOAN_PROCESS_PLAN_DETAIL = "GET_LOAN_PROCESS_PLAN_DETAIL";
export const GET_PROJECT_MORTGAGE_ELIGIBLE_FILE =
  "GET_PROJECT_MORTGAGE_ELIGIBLE_FILE";
export const GET_LOAN_PROCESS_STATUS_FOR_UPDATE =
  "GET_LOAN_PROCESS_STATUS_FOR_UPDATE";
export const GET_PROJECT_LOAN_FILTER_PROJECT =
  "GET_PROJECT_LOAN_FILTER_PROJECT";
export const GET_PROJECT_LOAN_FILTER_BANK = "GET_PROJECT_LOAN_FILTER_BANK";
export const GET_LOAN_PROCESS_PLAN_FILTER_PROJECT =
  "GET_LOAN_PROCESS_PLAN_FILTER_PROJECT";
export const GET_LOAN_PROCESS_PLAN_FILTER_BANK =
  "GET_LOAN_PROCESS_PLAN_FILTER_BANK";
export const GET_LOAN_PROCESS_PLAN_FILTER_PANEL =
  "GET_LOAN_PROCESS_PLAN_FILTER_PANEL";
export const GET_LOAN_PROCESS_PLAN_FILTER_PROCESS =
  "GET_LOAN_PROCESS_PLAN_FILTER_PROCESS";
export const GET_LOAN_PROCESS_PLAN_FOR_QUERY_CREATE =
  "GET_LOAN_PROCESS_PLAN_FOR_QUERY_CREATE";
export const GET_LOAN_PROCESS_PLAN_QUERY = "GET_LOAN_PROCESS_PLAN_QUERY";
export const GET_LOAN_PROCESS_PLAN_QUERY_EXPORT =
  "GET_LOAN_PROCESS_PLAN_QUERY_EXPORT";
export const GET_LOAN_PROCESS_PLAN_QUERY_DETAIL =
  "GET_LOAN_PROCESS_PLAN_QUERY_DETAIL";
export const GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT =
  "GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT";
export const GET_LOAN_PROCESS_PLAN_QUERY_FILTER_BANK =
  "GET_LOAN_PROCESS_PLAN_QUERY_FILTER_BANK";
export const GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PANEL =
  "GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PANEL";
export const GET_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE =
  "GET_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE";
export const GET_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE =
  "GET_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE";
export const GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS =
  "GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS";
export const GET_LOAN_PROCESS_PLAN_FILTER_RESPONSIBLE =
  "GET_LOAN_PROCESS_PLAN_FILTER_RESPONSIBLE";
export const GET_LOAN_PROCESS_PLAN_FILTER_ACCOUNTABLE =
  "GET_LOAN_PROCESS_PLAN_FILTER_ACCOUNTABLE";
export const GET_LOAN_PROCESS_PLAN_QUERY_TEMPLATE =
  "GET_LOAN_PROCESS_PLAN_QUERY_TEMPLATE";
export const GET_LOAN_PROCESS_PLAN_QUERY_REPORT =
  "GET_LOAN_PROCESS_PLAN_QUERY_REPORT";
// Vendor Nithish
export const GET_VENDOR = "GET_VENDOR";
export const GET_CONSTITUTION_OF_FIRM = "GET_CONSTITUTION_OF_FIRM";
export const GET_VENDOR_DOCUMENTS = "GET_VENDOR_DOCUMENTS";
export const GET_VENDOR_DOCUMENT_TYPE = "GET_VENDOR_DOCUMENT_TYPE";
export const GET_VENDOR_SERVICE = "GET_VENDOR_SERVICE";
export const GET_VENDOR_SERVICE_MASTER = "GET_VENDOR_SERVICE_MASTER";
export const GET_VENDOR_CONTACT = "GET_VENDOR_CONTACT";
export const GET_VENDOR_ACCOUNT = "GET_VENDOR_ACCOUNT";
export const GET_VENDOR_ACCOUNT_DOCUMENT_TYPE =
  "GET_VENDOR_ACCOUNT_DOCUMENT_TYPE";
export const GET_VENDOR_ADDRESS = "GET_VENDOR_ADDRESS";
export const GET_STATE = "GET_STATE";
export const GET_VENDOR_ACTION_HISTORY = "GET_VENDOR_ACTION_HISTORY";
export const UPDATE_VENDOR = "UPDATE_VENDOR";
export const GET_VENDOR_DETAILS = "GET_VENDOR_DETAILS";
export const GET_ACCOUNT_PAYMENT_FILTER_COMPANY =
  "GET_ACCOUNT_PAYMENT_FILTER_COMPANY";
export const GET_ACCOUNT_PAYMENT_FILTER_PROJECT =
  "GET_ACCOUNT_PAYMENT_FILTER_PROJECT";
export const GET_ACCOUNT_PAYMENT_FILTER_REQUESTED_BY =
  "GET_ACCOUNT_PAYMENT_FILTER_REQUESTED_BY";
export const GET_ACCOUNT_PAYMENT_FILTER_CATEGORY =
  "GET_ACCOUNT_PAYMENT_FILTER_CATEGORY";
export const GET_CHANNEL_PATNER_FILTER_RELATIONSHIP =
  "GET_CHANNEL_PATNER_FILTER_RELATIONSHIP";
export const GET_VENDOR_CHANGE_REQUEST = "GET_VENDOR_CHANGE_REQUEST";
export const GET_VENDOR_CHANGE_REQUEST_DETAILS =
  "GET_VENDOR_CHANGE_REQUEST_DETAILS";
export const GET_CIVIL_PROJECT_BILL_ACCOUNT = "GET_CIVIL_PROJECT_BILL_ACCOUNT";
export const GET_CIVIL_PROJECT_BILL_ACCOUNT_EXPORT =
  "GET_CIVIL_PROJECT_BILL_ACCOUNT_EXPORT";
export const GET_VENDOR_EXPORT = "GET_VENDOR_EXPORT";
export const GET_CHANNEL_PARTNER = "GET_CHANNEL_PARTNER";
export const GET_CHANNEL_PARTNER_EXPORT = "GET_CHANNEL_PARTNER_EXPORT";
export const GET_VENDOR_DETAILS_PRINT = "GET_VENDOR_DETAILS_PRINT";
//govt fees
export const GET_GOVT_FEES = "GET_GOVT_FEES";
export const GET_GOVT_FEES_PROCESS_PLAN = "GET_GOVT_FEES_PROCESS_PLAN";
export const GET_GOVERNMENT_DETAIL = "GET_GOVERNMENT_DETAIL";
export const GET_GOVT_FEES_PROCESS_ITEM = "GET_GOVT_FEES_PROCESS_ITEM";
export const GET_GOVT_FEES_ITEM = "GET_GOVT_FEES_ITEM";
export const GET_GOVT_FEES_PROJECT_FILTER = "GET_GOVT_FEES_PROJECT_FILTER";
export const GET_GOVT_FEES_PROCESS_FILTER = "GET_GOVT_FEES_PROCESS_FILTER";
export const GET_GOVT_FEES_FILTER_COMPANY = "GET_GOVT_FEES_FILTER_COMPANY";
export const GET_GOVT_FEE_SURVEY_NUMBER = "GET_GOVT_FEE_SURVEY_NUMBER";
export const GET_RETENTION_PERCENTAGE = "GET_RETENTION_PERCENTAGE";
export const GET_RETENTION_PERCENTAGE_FILTER_BILL_CATEGORY =
  "GET_RETENTION_PERCENTAGE_FILTER_BILL_CATEGORY";
export const GET_RETENTION_PERCENTAGE_EXPORT =
  "GET_RETENTION_PERCENTAGE_EXPORT";
export const GET_BILL_CATEGORY = "GET_BILL_CATEGORY";
export const GET_GOVT_FEES_TASK_PLAN = "GET_GOVT_FEES_TASK_PLAN";
export const GET_GOVT_FEES_FILTER_REQUESTED_BY =
  "GET_GOVT_FEES_FILTER_REQUESTED_BY";

//VendorLager
export const GET_VENDOR_LEDGER = "GET_VENDOR_LEDGER";
export const GET_VENDOR_LEDGER_EXPORT = "GET_VENDOR_LEDGER_EXPORT";
export const GET_VENDOR_LEDGER_DETAILS = "GET_VENDOR_LEDGER_DETAILS";
export const GET_VENDOR_FOR_LEDGER = "GET_VENDOR_FOR_LEDGER";
export const VENDOR_LEDGER_ITEM = "VENDOR_LEDGER_ITEM";
export const GET_VENDOR_LEDGER_ITEM_EXPORT = "GET_VENDOR_LEDGER_ITEM_EXPORT";
export const GET_VENDOR_LEDGER_ITEM_PRINT = "GET_VENDOR_LEDGER_ITEM_PRINT";
export const GET_VENDOR_LEDGER_FILTER_VENDOR =
  "GET_VENDOR_LEDGER_FILTER_VENDOR";
export const GET_VENDOR_LEDGER_FILTER_COMPANY =
  "GET_VENDOR_LEDGER_FILTER_COMPANY";
export const GET_VENDOR_LEDGER_ITEM_FILTER_VENDOR =
  "GET_VENDOR_LEDGER_ITEM_FILTER_VENDOR";
export const GET_VENDOR_LEDGER_ITEM_FILTER_COMPANY =
  "GET_VENDOR_LEDGER_ITEM_FILTER_COMPANY";
export const GET_VENDOR_LEDGER_ITEM_FILTER_PROJECT =
  "GET_VENDOR_LEDGER_ITEM_FILTER_PROJECT";
export const GET_VENDOR_LEDGER_ITEM_FILTER_CATEGORY =
  "GET_VENDOR_LEDGER_ITEM_FILTER_CATEGORY";
export const GET_PAYMENT_REQUEST = "GET_PAYMENT_REQUEST";
export const GET_PAYMENT_REQUEST_FILTER_PROJECT =
  "GET_PAYMENT_REQUEST_FILTER_PROJECT";
export const GET_PAYMENT_REQUEST_FILTER_VENDOR =
  "GET_PAYMENT_REQUEST_FILTER_VENDOR";
export const GET_PAYMENT_REQUEST_FILTER_CATEGORY =
  "GET_PAYMENT_REQUEST_FILTER_CATEGORY";
export const GET_PAYMENT_REQUEST_FILTER_REQUESTED_BY =
  "GET_PAYMENT_REQUEST_FILTER_REQUESTED_BY";
export const GET_PAYMENT_REQUEST_FILTER_COMPANY =
  "GET_PAYMENT_REQUEST_FILTER_COMPANY";
export const GET_PAYMENT_REQUEST_EXPORT = "GET_PAYMENT_REQUEST_EXPORT";
export const GET_PAYMENT_REQUEST_DETAIL = "GET_PAYMENT_REQUEST_DETAIL";
export const GET_VENDOR_ACCOUNT_FOR_PAYMENT_REQUEST =
  "GET_VENDOR_ACCOUNT_FOR_PAYMENT_REQUEST";
export const GET_PAYMENT_REQUEST_APPROVAL = "GET_PAYMENT_REQUEST_APPROVAL";
export const GET_PAYMENT_REQUEST_APPROVAL_EXPORT =
  "GET_PAYMENT_REQUEST_APPROVAL_EXPORT";
export const GET_PAYMENT_REQUEST_APPROVAL_FILTER_PROJECT =
  "GET_PAYMENT_REQUEST_APPROVAL_FILTER_PROJECT";
export const GET_PAYMENT_REQUEST_APPROVAL_FILTER_VENDOR =
  "GET_PAYMENT_REQUEST_APPROVAL_FILTER_VENDOR";
export const GET_PAYMENT_REQUEST_APPROVAL_FILTER_COMPANY =
  "GET_PAYMENT_REQUEST_APPROVAL_FILTER_COMPANY";
export const GET_PAYMENT_REQUEST_APPROVAL_FILTER_CATEGORY =
  "GET_PAYMENT_REQUEST_APPROVAL_FILTER_CATEGORY";
export const GET_ACCOUNT_CHEQUE_NUMBER = "GET_ACCOUNT_CHEQUE_NUMBER";
export const GET_CATEGORY_FOR_PAYMENT_REQUEST =
  "GET_CATEGORY_FOR_PAYMENT_REQUEST";
export const GET_VENDOR_PAYMENT_INFO_FOR_PAYMENT_REQUEST =
  "GET_VENDOR_PAYMENT_INFO_FOR_PAYMENT_REQUEST";
export const GET_VENDOR_PO_WO_FOR_PAYMENT_REQUEST =
  "GET_VENDOR_PO_WO_FOR_PAYMENT_REQUEST";
export const GET_COMPANY_FOR_PAYMENT_REQUEST =
  "GET_COMPANY_FOR_PAYMENT_REQUEST";
export const GET_PROJECT_FOR_PAYMENT_REQUEST =
  "GET_PROJECT_FOR_PAYMENT_REQUEST";
export const GET_VENDOR_FOR_PAYMENT_REQUEST = "GET_VENDOR_FOR_PAYMENT_REQUEST";
//Account Payment Paid
export const GET_PAYMENT_REQUEST_PAID = "GET_PAYMENT_REQUEST_PAID";
export const GET_PAYMENT_REQUEST_PAID_EXPORT =
  "GET_PAYMENT_REQUEST_PAID_EXPORT";
export const GET_PAYMENT_REQUEST_PAID_DETAIL =
  "GET_PAYMENT_REQUEST_PAID_DETAIL";
export const GET_PAYMENT_REQUEST_PAID_FILTER_COMPANY =
  "GET_PAYMENT_REQUEST_PAID_FILTER_COMPANY";
//TDS Master
export const GET_TDS_DEDUCTION = "GET_TDS_DEDUCTION";
export const GET_TDS_DEDUCTION_EXPORT = "GET_TDS_DEDUCTION_EXPORT";
export const GET_TDS_DEDUCTION_FILTER_CATEGORY =
  "GET_TDS_DEDUCTION_FILTER_CATEGORY";
export const GET_TDS_DEDUCTION_FILTER_VENDOR =
  "GET_TDS_DEDUCTION_FILTER_VENDOR";
//Expenses Invoice
export const GET_COST_CENTER_EXPORT = "GET_COST_CENTER_EXPORT";
export const GET_COST_CENTER_CATEGORY_EXPORT =
  "GET_COST_CENTER_CATEGORY_EXPORT";
export const GET_PAYMENT_CATEGORY_MASTER_EXPORT =
  "GET_PAYMENT_CATEGORY_MASTER_EXPORT";
export const GET_COST_CENTER = "GET_COST_CENTER";
export const GET_ITEM_FOR_EXPENSES = "GET_ITEM_FOR_EXPENSES";
export const GET_EXPENSES_INVOICE = "GET_EXPENSES_INVOICE";
export const GET_EXPENSES_INVOICE_EXPORT = "GET_EXPENSES_INVOICE_EXPORT";
export const GET_EXPENSES_INVOICE_DETAIL = "GET_EXPENSES_INVOICE_DETAIL";
export const GET_EXPENSES_INVOICE_FILTER_PROJECT =
  "GET_EXPENSES_INVOICE_FILTER_PROJECT";
export const GET_EXPENSES_INVOICE_FILTER_VENDOR =
  "GET_EXPENSES_INVOICE_FILTER_VENDOR";
export const GET_EXPENSES_INVOICE_FILTER_COMPANY =
  "GET_EXPENSES_INVOICE_FILTER_COMPANY";
export const GET_EXPENSES_INVOICE_FILTER_COST_CENTER =
  "GET_EXPENSES_INVOICE_FILTER_COST_CENTER";
export const GET_COMPANY_ACCOUNT_MAP = "GET_COMPANY_ACCOUNT_MAP";
export const GET_COMPANY_ACCOUNT_MAP_FILTER_COMPANY =
  "GET_COMPANY_ACCOUNT_MAP_FILTER_COMPANY";
export const GET_COMPNAY_ACCOUNT_MAP_FILTER_BANK =
  "GET_COMPNAY_ACCOUNT_MAP_FILTER_BANK";
export const GET_COMPANY_ACCOUNT_MAP_EXPORT = "GET_COMPANY_ACCOUNT_MAP_EXPORT";

export const GET_SERVICE_FOR_VENDOR = "GET_SERVICE_FOR_VENDOR";

//loan summary
export const GET_PROJECT_LONE_SUMMARY = "GET_PROJECT_LONE_SUMMARY";
export const GET_PROJECT_LONE_SUMMARY_EXPORT =
  "GET_PROJECT_LONE_SUMMARY_EXPORT";

export const GET_SURVEY_NUMBER_FOR_LOAN_QUERY =
  "GET_SURVEY_NUMBER_FOR_LOAN_QUERY";

//petty cash
export const GET_PETTY_CASH = "GET_PETTY_CASH";
export const GET_PETTY_CASH_EXPORT = "GET_PETTY_CASH_EXPORT";
export const GET_PETTY_CASH_DETAIL = "GET_PETTY_CASH_DETAIL";
export const GET_PETTY_CASH_FILTER_PROJECT = "GET_PETTY_CASH_FILTER_PROJECT";
export const GET_PETTY_CASH_FILTER_DEPARTMENT =
  "GET_PETTY_CASH_FILTER_DEPARTMENT";
export const GET_PETTY_CASH_FILTER_REQUESTED_BY =
  "GET_PETTY_CASH_FILTER_REQUESTED_BY";
export const GET_PETTY_CASH_FILTER_COMPANY = "GET_PETTY_CASH_FILTER_COMPANY";
export const GET_COST_CENTER_FOR_PETTY_CASH = "GET_COST_CENTER_FOR_PETTY_CASH";
//Payment realisation (sadanand)
export const GET_PAYMENT_REQUEST_PAID_ITEM = "GET_PAYMENT_REQUEST_PAID_ITEM";
export const GET_PAYMENT_REQUEST_PAID_ITEM_EXPORT =
  "GET_PAYMENT_REQUEST_PAID_ITEM_EXPORT";
export const GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_COMPANY =
  "GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_COMPANY";
export const GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_VENDOR =
  "GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_VENDOR";
export const GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_BANK =
  "GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_BANK";
export const GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_ACCOUNT =
  "GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_ACCOUNT";
export const GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_CATEGORY =
  "GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_CATEGORY";

export const GET_EXPENSES_INVOICE_FILTER_CATEGORY =
  "GET_EXPENSES_INVOICE_FILTER_CATEGORY";

export const GET_PAYMENT_CATEGORY_MASTER = "GET_PAYMENT_CATEGORY_MASTER";

//SALARY JV
export const GET_SALARY_JV = "GET_SALARY_JV";
export const GET_SALARY_EMPLOYER_PF_DETAIL = "GET_SALARY_EMPLOYER_PF_DETAIL";
export const GET_SALARY_EMPLOYER_ESI_DETAIL = "GET_SALARY_EMPLOYER_ESI_DETAIL";
export const GET_SALARY_ADVANCE_DETAIL = "GET_SALARY_ADVANCE_DETAIL";

export const GET_SALARY_JV_EXPORT = "GET_SALARY_JV_EXPORT";
export const GET_SALARY_JV_FILTER_COMPANY = "GET_SALARY_JV_FILTER_COMPANY";
export const GET_SALARY_JV_DETAIL = "GET_SALARY_JV_DETAIL";

export const GET_COST_CENTER_CATEGORY = "GET_COST_CENTER_CATEGORY";
export const GET_TDS_FOR_BILL = "GET_TDS_FOR_BILL";
export const GET_COST_CENTER_MASTER = "GET_COST_CENTER_MASTER";

export const GET_EXPENSES_INVOICE_ACCOUNT = "GET_EXPENSES_INVOICE_ACCOUNT";
export const GET_EXPENSES_INVOICE_ACCOUNT_EXPORT =
  "GET_EXPENSES_INVOICE_ACCOUNT_EXPORT";
export const GET_EXPENSES_INVOICE_ACCOUNT_FILTER_PROJECT =
  "GET_EXPENSES_INVOICE_ACCOUNT_FILTER_PROJECT";
export const GET_EXPENSES_INVOICE_ACCOUNT_FILTER_VENDOR =
  "GET_EXPENSES_INVOICE_ACCOUNT_FILTER_VENDOR";
export const GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COMPANY =
  "GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COMPANY";
export const GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COSTCENTER =
  "GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COSTCENTER";
export const GET_EXPENSES_INVOICE_ACCOUNT_FILTER_CATEGORY =
  "GET_EXPENSES_INVOICE_ACCOUNT_FILTER_CATEGORY";
export const GET_PAYMENT_CATEGORY_FOR_EXPENSE =
  "GET_PAYMENT_CATEGORY_FOR_EXPENSE";
// --CM-----------
export const GET_STOCK_COMPANY = "GET_STOCK_COMPANY";
export const GET_STOCK_COMPANY_DETAILS = "GET_STOCK_COMPANY_DETAILS";
export const GET_STOCK_COMPANY_EXPORT = "GET_STOCK_COMPANY_EXPORT";
export const GET_DIRECTOR_TYPE = "GET_DIRECTOR_TYPE";

//Payment Receit
export const GET_PAYMENT_RECIEVED = "GET_PAYMENT_RECIEVED";
export const GET_PAYMENT_RECIEVED_EXPORT = "GET_PAYMENT_RECIEVED_EXPORT";
export const GET_SALARY_EXPENSE_OTHER_DEDUCTION =
  "GET_SALARY_EXPENSE_OTHER_DEDUCTION";
export const GET_SALARY_EXPENSE_OTHER_DEDUCTION_EXPORT =
  "GET_SALARY_EXPENSE_OTHER_DEDUCTION_EXPORT";
export const GET_CUSTOMER_FOR_PAYMENT_RECIEVED =
  "GET_CUSTOMER_FOR_PAYMENT_RECIEVED";
export const GET_PAYMENT_RECIEVED_FILTER_COMPANY =
  "GET_PAYMENT_RECIEVED_FILTER_COMPANY";
export const GET_PAYMENT_RECIEVED_FILTER_PROJECT =
  "GET_PAYMENT_RECIEVED_FILTER_PROJECT";
export const GET_PAYMENT_RECIEVED_FILTER_ACCOUNT =
  "GET_PAYMENT_RECIEVED_FILTER_ACCOUNT";
export const GET_PAYMENT_RECIEVED_FILTER_CUSTOMER =
  "GET_PAYMENT_RECIEVED_FILTER_CUSTOMER";
export const GET_PAYMENT_RECIEVED_FILTER_BANK =
  "GET_PAYMENT_RECIEVED_FILTER_BANK";
export const GET_PAYMENT_RECIEVED_FILTER_STATUS =
  "GET_PAYMENT_RECIEVED_FILTER_STATUS";
export const GET_PAYMENT_RECIEVED_DETAIL = "GET_PAYMENT_RECIEVED_DETAIL";
export const GET_PAYMENT_RECEIPT_FILTER_SITE_NUMBER =
  "GET_PAYMENT_RECEIPT_FILTER_SITE_NUMBER";
export const GET_PAYMENT_RECEIPT_FILTER_CATEGORY =
  "GET_PAYMENT_RECEIPT_FILTER_CATEGORY";
export const GET_PAYMENT_STATUS = "GET_PAYMENT_STATUS";
//vehicle fuel Bill
export const GET_VEHICLE_FUEL = "GET_VEHICLE_FUEL";
export const GET_VEHICLE_FUEL_EXPORT = "GET_VEHICLE_FUEL_EXPORT";
export const GET_VEHICLE_FUEL_DETAILS = "GET_VEHICLE_FUEL_DETAILS";
export const GET_VEHICLE_FUEL_FILTER_EMPLOYEE =
  "GET_VEHICLE_FUEL_FILTER_EMPLOYEE";
export const GET_VEHICLE_FUEL_FILTER_PROJECT =
  "GET_VEHICLE_FUEL_FILTER_PROJECT";
export const GET_VENDOR_LEDGER_FILTER_CATEGORY =
  "GET_VENDOR_LEDGER_FILTER_CATEGORY";

// ----ChequeBook--------
export const GET_CHEQUE_BOOK = "GET_CHEQUE_BOOK";
export const GET_CHEQUE_BOOK_EXPORT = "GET_CHEQUE_BOOK_EXPORT";
export const GET_CHEQUE_BOOK_FILTER_COMPANY = "GET_CHEQUE_BOOK_FILTER_COMPANY";
export const GET_CHEQUE_BOOK_FILTER_ACCOUNT = "GET_CHEQUE_BOOK_FILTER_ACCOUNT";

export const GET_CHEQUE_BOOK_USAGE = "GET_CHEQUE_BOOK_USAGE";
export const GET_CHEQUE_BOOK_USAGE_EXPORT = "GET_CHEQUE_BOOK_USAGE_EXPORT";
export const GET_CHEQUE_BOOK_USAGE_FILTER_COMPANY =
  "GET_CHEQUE_BOOK_USAGE_FILTER_COMPANY";
export const GET_CHEQUE_BOOK_USAGE_FILTER_ACCOUNT =
  "GET_CHEQUE_BOOK_USAGE_FILTER_ACCOUNT";
export const GET_CHEQUE_BOOK_USAGE_FILTER_STATUS =
  "GET_CHEQUE_BOOK_USAGE_FILTER_STATUS";
export const GET_CHEQUE_BOOK_STATUS = "GET_CHEQUE_BOOK_STATUS";
export const GET_CHEQUE_BOOK_NUMBER_FOR_CHEQUE =
  "GET_CHEQUE_BOOK_NUMBER_FOR_CHEQUE";
export const GET_COMPANY_FOR_CHEQUE_USAGE = "GET_COMPANY_FOR_CHEQUE_USAGE";
export const GET_CHEQUE_BOOK_DETAILS = "GET_CHEQUE_BOOK_DETAILS";
export const GET_CHEQUE_BOOK_USAGE_DETAILS = "GET_CHEQUE_BOOK_USAGE_DETAILS";

export const GET_CARD = "GET_CARD";
export const GET_CARD_EXPORT = "GET_CARD_EXPORT";
export const IMPORT_CHANNEL_PARTNER = "IMPORT_CHANNEL_PARTNER";
export const GET_GOVT_FEES_MODE_CATEGORY = "GET_GOVT_FEES_MODE_CATEGORY";
export const GET_DEMAND_DRAFT_REQUEST = "GET_DEMAND_DRAFT_REQUEST";
export const GET_DEMAND_DRAFT_REQUEST_DETAIL =
  "GET_DEMAND_DRAFT_REQUEST_DETAIL";
export const GET_DEMAND_DRAFT_REQUEST_FILTER_PROJECT =
  "GET_DEMAND_DRAFT_REQUEST_FILTER_PROJECT";
export const GET_DEMAND_DRAFT_REQUEST_FILTER_VENDOR =
  "GET_DEMAND_DRAFT_REQUEST_FILTER_VENDOR";

//Petty Cash Vendor By Nithish Aug 11 2025

export const GET_VENDOR_FILTER_SERVICE = "GET_VENDOR_FILTER_SERVICE";
export const GET_PETTY_CASH_ACCOUNTS = "GET_PETTY_CASH_ACCOUNTS";
export const GET_PETTY_CASH_ACCOUNTS_EXPORT = "GET_PETTY_CASH_ACCOUNTS_EXPORT";
export const GET_PETTY_CASH_ACCOUNTS_FILTER_PROJECT =
  "GET_PETTY_CASH_ACCOUNTS_FILTER_PROJECT";
export const GET_PETTY_CASH_ACCOUNTS_FILTER_COMPANY =
  "GET_PETTY_CASH_ACCOUNTS_FILTER_COMPANY";
export const GET_PETTY_CASH_ACCOUNTS_FILTER_REQUESTED_BY =
  "GET_PETTY_CASH_ACCOUNTS_FILTER_REQUESTED_BY";
export const GET_PETTY_CASH_ACCOUNTS_FILTER_DEPARTMENT =
  "GET_PETTY_CASH_ACCOUNTS_FILTER_DEPARTMENT";
export const GET_PETTY_CASH_SETTING = "GET_PETTY_CASH_SETTING";
export const GET_COMPANY_FOR_ASSET_GROUP = "GET_COMPANY_FOR_ASSET_GROUP";

// Director
export const GET_DIRECTOR = "GET_DIRECTOR";
export const GET_DIRECTOR_DETAIL = "GET_DIRECTOR_DETAIL";
export const GET_DOCUMENT_TYPE = "GET_DOCUMENT_TYPE";
export const GET_DIN_VERIFICATION = "GET_DIN_VERIFICATION";
export const GET_DIN_VERIFICATION_DETAIL = "GET_DIN_VERIFICATION_DETAIL";
export const GET_PAYMENT_RECEIVED_STATUS = "GET_PAYMENT_RECEIVED_STATUS";
export const GET_STATUS_FOR_PAYMENT_RECEIPT = "GET_STATUS_FOR_PAYMENT_RECEIPT";
export const GET_REASON_FOR_NOT_REALIZED_PAYMENT =
  "GET_REASON_FOR_NOT_REALIZED_PAYMENT";
export const GET_LEASE = "GET_LEASE";
export const GET_LEASE_FILTER_LESSEE = "GET_LEASE_FILTER_LESSEE";
export const GET_LEASE_FILTER_LESSOR = "GET_LEASE_FILTER_LESSOR";
export const GET_LEASE_DETAIL = "GET_LEASE_DETAIL";

// RERA-Applivcation
export const GET_RERA_APPLICATION = "GET_RERA_APPLICATION";
export const GET_RERA_APPLICATION_EXPORT = "GET_RERA_APPLICATION_EXPORT";
export const GET_RERA_AUTHORITIES = "GET_RERA_AUTHORITIES";
export const GET_RERA_APPLICATION_DETAIL = "GET_RERA_APPLICATION_DETAIL";
export const GET_RERA_QUERY = "GET_RERA_QUERY";
export const GET_RERA_QUERY_EXPORT = "GET_RERA_QUERY_EXPORT";
export const GET_RERA_APPLICATION_PROJECT = "GET_RERA_APPLICATION_PROJECT";
export const GET_RERA_QUERY_PROJECT = "GET_RERA_QUERY_PROJECT";
export const GET_RERA_QUERY_DETAILS = "GET_RERA_QUERY_DETAILS";
export const GET_RERA_QUERY_FILTER_PROJECT = "GET_RERA_QUERY_FILTER_PROJECT";
export const GET_RERA_APPLICATION_FILTER_PROJECT =
  "GET_RERA_APPLICATION_FILTER_PROJECT";
export const GET_RERA_QUERY_FILTER_RESPONSIBLE =
  "GET_RERA_QUERY_FILTER_RESPONSIBLE";
export const GET_RERA_QUERY_FILTER_ACCOUNTABLE =
  "GET_RERA_QUERY_FILTER_ACCOUNTABLE";
export const GET_RERA_FILING = "GET_RERA_FILING";
export const GET_RERA_FILING_EXPORT = "GET_RERA_FILING_EXPORT";
export const GET_RERA_FILING_DETAIL = "GET_RERA_FILING_DETAIL";
export const GET_RERA_FILING_FILTER_PROJECT = "GET_RERA_FILING_FILTER_PROJECT";
export const GET_CARD_DETAILS = "GET_CARD_DETAILS";

// Loan
export const GET_LOAN_CATEGORY = "GET_LOAN_CATEGORY";
export const GET_LOAN_CATEGORY_EXPORT = "GET_LOAN_CATEGORY_EXPORT";
export const GET_LOAN_SECURITY = "GET_LOAN_SECURITY";
export const GET_LOAN_SECURITY_EXPORT = "GET_LOAN_SECURITY_EXPORT";
export const GET_LOAN_SECURITY_FILTER_COMPANY =
  "GET_LOAN_SECURITY_FILTER_COMPANY";
export const GET_LOAN_SECURITY_FILTER_BANK = "GET_LOAN_SECURITY_FILTER_BANK";
export const GET_LOAN = "GET_LOAN";
export const GET_LOAN_EXPORT = "GET_LOAN_EXPORT";
export const GET_LOAN_DETAILS = "GET_LOAN_DETAILS";
export const GET_LOAN_PENALTY_REASON = "GET_LOAN_PENALTY_REASON";
export const GET_LOAN_FILTER_COMPANY = "GET_LOAN_FILTER_COMPANY";
export const GET_LOAN_FILTER_BANK = "GET_LOAN_FILTER_BANK";
export const GET_LOAN_FILTER_CATEGORY = "GET_LOAN_FILTER_CATEGORY";
export const GET_LAND_FOR_LOAN_SECURITY = "GET_LAND_FOR_LOAN_SECURITY";
export const GET_SITE_FOR_LOAN_SECURITY = "GET_SITE_FOR_LOAN_SECURITY";
export const GET_LOAN_PENALTY_REASON_EXPORT = "GET_LOAN_PENALTY_REASON_EXPORT";
export const GET_LOAN_SECURITY_FILTER_PROJECT =
  "GET_LOAN_SECURITY_FILTER_PROJECT";
export const GET_LOAN_SECURITY_FILTER_LENDER =
  "GET_LOAN_SECURITY_FILTER_LENDER";
export const GET_LOAN_FILTER_LENDER = "GET_LOAN_FILTER_LENDER";

// chaque usage
export const GET_CHEQUE_BOOK_USAGE_REPORT = "GET_CHEQUE_BOOK_USAGE_REPORT";
export const GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS =
  "GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS";
export const GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS_EXPORT =
  "GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS_EXPORT";

// TDS Section(SVM)
export const GET_TDS_SECTION = "GET_TDS_SECTION";
export const GET_TDS_SECTION_EXPORT = "GET_TDS_SECTION_EXPORT";
export const GET_TDS_SECTION_DETAIL = "GET_TDS_SECTION_DETAIL";
export const GET_TDS_DEDUCTION_DETAIL = "GET_TDS_DEDUCTION_DETAIL";
export const GET_VENDOR_FOR_TDS_DEDUCTION = "GET_VENDOR_FOR_TDS_DEDUCTION";

// current year month and Rent Bill
export const GET_CURRENT_YEAR_MONTH = "GET_CURRENT_YEAR_MONTH";
export const GET_RENT_DETAIL_FOR_RENT_BILL = "GET_RENT_DETAIL_FOR_RENT_BILL";

// consultant fees
export const GET_PROJECT_CONSULTANT = "GET_PROJECT_CONSULTANT";
export const GET_PROJECT_CONSULTANT_FEE = "GET_PROJECT_CONSULTANT_FEE";
export const GET_PROJECT_CONSULTANT_FEE_EXPORT =
  "GET_PROJECT_CONSULTANT_FEE_EXPORT";
export const GET_PROJECT_CONSULTANT_FEE_DETAIL =
  "GET_PROJECT_CONSULTANT_FEE_DETAIL";
export const GET_SURVEY_FOR_PROJECT_CONSULTANT_FEE =
  "GET_SURVEY_FOR_PROJECT_CONSULTANT_FEE";
export const GET_PROJECT_CONSULTANT_FEE_FILTER_PROJECT =
  "GET_PROJECT_CONSULTANT_FEE_FILTER_PROJECT";
export const GET_PROJECT_CONSULTANT_FEE_FILTER_CONSULTANT =
  "GET_PROJECT_CONSULTANT_FEE_FILTER_CONSULTANT";

// Cheque Template(SVM)
export const GET_CHEQUE_TEMPLATE = "GET_CHEQUE_TEMPLATE";
export const GET_CHEQUE_TEMPLATE_EXPORT = "GET_CHEQUE_TEMPLATE_EXPORT";
export const GET_CHEQUE_TEMPLATE_DETAIL = "GET_CHEQUE_TEMPLATE_DETAIL";
export const GET_CHEQUE_TEMPLATE_FILTER_BANK =
  "GET_CHEQUE_TEMPLATE_FILTER_BANK";

//customer ledger
export const GET_CUSTOMER_LEDGER = "GET_CUSTOMER_LEDGER";
export const GET_CUSTOMER_LEDGER_ITEM_PRINT = "GET_CUSTOMER_LEDGER_ITEM_PRINT";
export const GET_CUSTOMER_LEDGER_EXPORT = "GET_CUSTOMER_LEDGER_EXPORT";
export const GET_CUSTOMER_LEDGER_DETAIL = "GET_CUSTOMER_LEDGER_DETAIL";
export const GET_CUSTOMER_LEDGER_FILTER_PROJECT =
  "GET_CUSTOMER_LEDGER_FILTER_PROJECT";
export const GET_CUSTOMER_LEDGER_FILTER_CUSTOMER =
  "GET_CUSTOMER_LEDGER_FILTER_CUSTOMER";
export const GET_CUSTOMER_LEDGER_FILTER_COMPANY =
  "GET_CUSTOMER_LEDGER_FILTER_COMPANY";
export const GET_CUSTOMER_LEDGER_FILTER_CATEGORY =
  "GET_CUSTOMER_LEDGER_FILTER_CATEGORY";
export const GET_CUSTOMER_LEDGER_ITEM = "GET_CUSTOMER_LEDGER_ITEM";
export const GET_CUSTOMER_LEDGER_ITEM_EXPORT =
  "GET_CUSTOMER_LEDGER_ITEM_EXPORT";
export const GET_CUSTOMER_LEDGER_ITEM_FILTER_CUSTOMER =
  "GET_CUSTOMER_LEDGER_ITEM_FILTER_CUSTOMER";
export const GET_CUSTOMER_LEDGER_ITEM_FILTER_COMPANY =
  "GET_CUSTOMER_LEDGER_ITEM_FILTER_COMPANY";
export const GET_CUSTOMER_LEDGER_ITEM_FILTER_CATEGORY =
  "GET_CUSTOMER_LEDGER_ITEM_FILTER_CATEGORY";
export const GET_CUSTOMER_LEDGER_ITEM_FILTER_PROJECT =
  "GET_CUSTOMER_LEDGER_ITEM_FILTER_PROJECT";

// sales return (Credit Note)
export const GET_SALES_RETURN = "GET_SALES_RETURN";
export const GET_SALES_RETURN_DETAIL = "GET_SALES_RETURN_DETAIL";
export const GET_SALES_RETURN_FILTER_PROJECT =
  "GET_SALES_RETURN_FILTER_PROJECT";
export const GET_SALES_RETURN_FILTER_COMPANY =
  "GET_SALES_RETURN_FILTER_COMPANY";
export const GET_SALES_RETURN_EXPORT = "GET_SALES_RETURN_EXPORT";

//account type
export const GET_ACCOUNT_TYPE = "GET_ACCOUNT_TYPE";
